import { render, staticRenderFns } from "./contest-sort.vue?vue&type=template&id=624e2696&scoped=true"
import script from "./contest-sort.vue?vue&type=script&lang=js"
export * from "./contest-sort.vue?vue&type=script&lang=js"
import style0 from "./contest-sort.vue?vue&type=style&index=0&id=624e2696&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e2696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624e2696')) {
      api.createRecord('624e2696', component.options)
    } else {
      api.reload('624e2696', component.options)
    }
    module.hot.accept("./contest-sort.vue?vue&type=template&id=624e2696&scoped=true", function () {
      api.rerender('624e2696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-sort.vue"
export default component.exports